import React from 'react';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { VIPPS_ERROR_RESET } from '../../constants';
import Icon from '../Icon';
import { translate } from '../../Services/translation';

const VippsError = () => {

    const dispatch = useDispatch();
    const { vippsError } = useTypedSelector((state) => state.vippsError);

    const closeError = () => {
        dispatch({ type: VIPPS_ERROR_RESET });
    };

    if (!vippsError) {
        return null;
    }

    return (
        <div
            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50"
            onClick={closeError}
        >
            <div
                className="bg-white text-center justify-center mx-auto px-6 py-6 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 max-w-md w-full mx-4 shadow-lg"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <button
                    className="absolute top-3 right-3 text-grey-900 hover:cursor-pointer"
                    onClick={closeError}
                >
                    <Icon name="close" className="w-6 h-6 text-grey-900" />
                </button>

                <div className="mt-4">
                    <div className="flex justify-center mb-4">
                        <Icon name="warning" className="w-8 h-8 text-red-500" />
                    </div>
                    <h3 className="text-lg font-bold text-grey-900 mb-4">
                        {translate('vipps.error-modal-title')}
                    </h3>
                    <div className="text-grey-900 text-sm mb-6">
                        {translate('vipps.error-modal-text')}
                    </div>
                    <button
                        onClick={closeError}
                        className="w-full py-3 bg-primary-500 text-white font-bold hover:bg-primary-600 transition-colors"
                    >
                        {translate('vipps.error-modal-close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VippsError;
